import { AppUtils } from '../../utils/index';
import { AdresseModel } from './Adresse';
import { MembershipPersonalDataModel } from "./MembershipPersonalData";

/**
 * Model for one child on membership form.
 */
export class ChildModel {
	private id: string;
	private adresse: AdresseModel;
	private hatAbweichendeAdresse: boolean;
	private isJuv: boolean;
	private personalData: MembershipPersonalDataModel;

	constructor(initialProperties?: Partial<ChildModel>) {
		this.Adresse = new AdresseModel();
		this.PersonalData = new MembershipPersonalDataModel();

		if (initialProperties) {
			AppUtils.Helper.mapObject(initialProperties, this);
		}
	}

	get Id(): string {
		return this.id;
	}

	set Id(value: string) {
		this.id = value;
	}

	get PersonalData(): MembershipPersonalDataModel {
		return this.personalData;
	}

	set PersonalData(value: MembershipPersonalDataModel) {
		this.personalData = value;
	}

	get Anrede(): string {
		if (this.PersonalData.AnredeKennzeichen === 1) {
			return "Herr";
		}
		if (this.PersonalData.AnredeKennzeichen === 2) {
			return "Frau";
		}
		return "Divers";
	}

	get HatAbweichendeAdresse(): boolean {
		return this.hatAbweichendeAdresse;
	}

	set HatAbweichendeAdresse(value: boolean) {
		this.hatAbweichendeAdresse = value;
	}

	get Adresse(): AdresseModel {
		return this.adresse;
	}

	set Adresse(value: AdresseModel) {
		this.adresse = value;
	}

	get IsJuv(): boolean {
		return this.isJuv;
	}

	set IsJuv(value: boolean) {
		this.isJuv = value;
	}

	get Valid(): boolean {
		return (this.PersonalData.Vorname !== "" && this.PersonalData.Nachname !== "" && this.PersonalData.Geburtsdatum !== "");
	}

	public toString(): string {
		try {
			return JSON.stringify(this);
		} catch (e) {
			return Object.toString.apply(this);
		}
	}

	/**
	 * Creates a new model object and copies the values from the provided data object (or other application model) to the created model.
	 */
	static createFromObject(dataObject: { [key: string]: any }): ChildModel {
		return AppUtils.Helper.createFromMap(dataObject, ChildModel, (key, value) => {
			switch (key.toLowerCase()) {
				case 'adresse':
					return AdresseModel.createFromObject(value);
				case 'personaldata':
					return MembershipPersonalDataModel.createFromObject(value);
				default:
					return value;
			}
		});
	}
}
